import { Link } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export function ModalNoReferences({ isOpen, isClose, user }) {
  const getRatingExamText = () => {
    if (user) {
      const ratingExam = user.ratingExam ? user.ratingExam : user.rank;
      const userInfo = `${ratingExam} ${user.dutyState}`;
      return userInfo;
    }
    return '';
  };

  return (
    <Modal isOpen={isOpen} toggle={isClose} className="empty-state">
      <ModalHeader toggle={isClose}>NOTICE</ModalHeader>
      <ModalBody>
        <h2 className="empty-state__title">
          This AFSC has too little material to offer as a service.
        </h2>
        <br />
        <br />
        <p className="empty-state__subtitle">
          We made the decision to close this AFSC{' '}
          <strong>{getRatingExamText()}</strong> study plan down until we can
          offer more material.
        </p>

        <br />
        <br />
        {/* <p className="empty-state__subtitle">
          Or other option, if they wish, to choose the{' '}
          <strong>Warfare & Qualifications Only</strong> plan to study for quals
        </p> */}
      </ModalBody>
      <ModalFooter>
        <div>
          <Link to="/app/account-settings" className="text-default btn btnLink">
            Change AFSC exam
          </Link>
          <Button
            className="btn btn-primary btn-submit"
            onClick={() => {
              isClose();
            }}
          >
            Understood
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
